import { Plus } from "@phosphor-icons/react";
import { stories, currentUser } from "@/data/mockData";

export default function StoryRail() {
  return (
    <section
      data-testid="story-rail"
      className="border-b border-[#27272A] bg-[#050505]"
    >
      <div className="flex items-center justify-between px-4 md:px-6 pt-4">
        <h2 className="font-display font-bold uppercase tracking-tight text-sm">
          Historias
        </h2>
        <span className="font-mono text-[10px] text-[#A1A1AA] tracking-[0.2em]">
          LAST 24H
        </span>
      </div>

      <div className="flex gap-3 overflow-x-auto no-scrollbar px-4 md:px-6 py-4">
        {/* Your story */}
        <button
          data-testid="create-story"
          className="shrink-0 group relative w-[120px] aspect-[3/4] border border-dashed border-[#27272A] hover:border-[#FF3E00] bg-[#0a0a0a] flex flex-col items-center justify-center gap-2 transition-colors"
        >
          <div className="h-10 w-10 border border-[#FF3E00] text-[#FF3E00] flex items-center justify-center">
            <Plus size={18} weight="bold" />
          </div>
          <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#A1A1AA] group-hover:text-white">
            Tu historia
          </span>
        </button>

        {stories.map((s) => (
          <button
            key={s.id}
            data-testid={`story-${s.id}`}
            className="shrink-0 relative w-[120px] aspect-[3/4] overflow-hidden border border-[#27272A] hover:border-[#FF3E00] group transition-all"
          >
            <img
              src={s.cover}
              alt={s.artist.name}
              className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            {s.live ? (
              <div className="absolute top-2 left-2 font-mono text-[9px] uppercase tracking-[0.2em] bg-[#FF0033] text-white px-1.5 py-0.5 flex items-center gap-1">
                <span className="h-1 w-1 bg-white live-dot" />
                LIVE
              </div>
            ) : null}
            <div className="absolute bottom-0 inset-x-0 p-2">
              <div className="font-display font-bold text-[13px] leading-tight truncate">
                {s.artist.name.split(" ")[0]}
              </div>
              <div className="font-mono text-[9px] text-[#FF3E00] tracking-wider truncate">
                {s.label}
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
